import { Variables } from "./variables";

export const Errors = {
  header: `[${Variables.name.root} warn]:`,
  invalidProps: "Invalid props:",
  nullKeys: "Null keys:",
  formatError: "Format error:",
  typeError: "Type error:"
};
